// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"995":"3c9070dc","1269":"58f1af88","2990":"58f1af88","9009":"36e0c814","9863":"1bb6f0dd"}[chunkId] + ".chunk.css";
};